/** Store / installer links (same as TGBOT keyboards/inline.py). */

export type VpnAppProtocol = 'wg' | 'ovpn';

export interface VpnAppLink {
  id: string;
  label: string;
  href: string;
}

export const WG_APP_LINKS: VpnAppLink[] = [
  {
    id: 'wg-android',
    label: 'Android',
    href: 'https://play.google.com/store/apps/details?id=com.wireguard.android',
  },
  {
    id: 'wg-ios',
    label: 'iPhone',
    href: 'https://apps.apple.com/app/wireguard/id1441195209',
  },
  {
    id: 'wg-macos',
    label: 'macOS',
    href: 'https://apps.apple.com/app/wireguard/id1451685025',
  },
  {
    id: 'wg-windows',
    label: 'Windows',
    href: 'https://download.wireguard.com/windows-client/wireguard-installer.exe',
  },
];

export const OVPN_APP_LINKS: VpnAppLink[] = [
  {
    id: 'ovpn-android',
    label: 'Android',
    href: 'https://play.google.com/store/apps/details?id=net.openvpn.openvpn',
  },
  {
    id: 'ovpn-ios',
    label: 'iPhone',
    href: 'https://apps.apple.com/ru/app/openvpn-connect/id590379981',
  },
  {
    id: 'ovpn-macos',
    label: 'macOS',
    href: 'https://apps.apple.com/ru/app/openvpn-connect/id590379981',
  },
  {
    id: 'ovpn-windows',
    label: 'Windows',
    href: 'https://apps.microsoft.com/detail/xpdlgw32hhrb5p?referrer=appbadge&mode=full',
  },
];

export function vpnAppLinks(protocol: VpnAppProtocol): VpnAppLink[] {
  return protocol === 'ovpn' ? OVPN_APP_LINKS : WG_APP_LINKS;
}

export function parseWgInterfaceAddress(configText: string): string | null {
  for (const line of configText.split(/\r?\n/)) {
    const trimmed = line.trim();
    if (!/^address\s*=/i.test(trimmed)) continue;
    const raw = trimmed.split('=').slice(1).join('=').trim();
    for (const part of raw.split(',')) {
      const ip = part.trim().split('/')[0]?.trim();
      if (ip && /^(?:\d{1,3}\.){3}\d{1,3}$/.test(ip)) return ip;
    }
  }
  return null;
}
